export const RMA_REQUEST_STATUS = {
  PENDING: 'PENDING',
  REQUESTED: 'REQUESTED',
  COMPLETED: 'COMPLETED',
} as const;
